import { createFileRoute, redirect } from '@tanstack/react-router';

import { getEvaluationsOptions } from '@/module/Evaluation/model/EvaluationQuery';

import { NoContentPlaceholder } from '@/core/components';

export const Route = createFileRoute('/_auth/evaluation/_layout/')({
  loader: async ({ context: { queryClient } }) => {
    const data = await queryClient.ensureQueryData(getEvaluationsOptions());
    if (data.length > 0) {
      throw redirect({ to: String(data[0].id) });
    }
  },
  component: () => <NoContentPlaceholder title="Selectați anul raportării din partea stângă" />,
});
